import React, { useState, useEffect } from "react";
import { Table, Icon, Input, Button } from "semantic-ui-react";
import { map } from "lodash";
import { Tooltip } from "react-tooltip";

const RomanNumerals = {
  I: 1,
  II: 2,
  III: 3,
  IV: 4,
  V: 5,
  VI: 6,
  VII: 7,
  VIII: 8,
  IX: 9,
  X: 10,
};

export function TableMaterias(props) {
  const { materias, deleteMateria, updateMateria } = props;
  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [realTimeSearch, setRealTimeSearch] = useState("");
  const [planEstudioSearch, setPlanEstudioSearch] = useState("");

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
    setPlanEstudioSearch(planEstudioSearch.toLowerCase());
  }, [searchText, planEstudioSearch]);

  const handleRealTimeSearchChange = (value) => {
    setRealTimeSearch(value);
    setCurrentPage(1);
  };

  const handlePlanEstudioSearchChange = (value) => {
    setPlanEstudioSearch(value);
    setCurrentPage(1);
  };

  const compareSemester = (semA, semB) => {
    const semAValue = RomanNumerals[semA.toUpperCase()];
    const semBValue = RomanNumerals[semB.toUpperCase()];

    if (semAValue && semBValue) {
      return semAValue - semBValue;
    } else {
      return semA.localeCompare(semB); // Si no son números romanos válidos, se compara como strings
    }
  };

  const filteredMaterias = () => {
    if (!materias) return [];
    return materias.filter(
      (materia) =>
        materia.nombre_materia.toLowerCase().includes(realTimeSearch) &&
        materia.plan_estudio_data.descripcion
          .toLowerCase()
          .includes(planEstudioSearch)
    );
  };

  useEffect(() => {
    const lastPage = Math.ceil(filteredMaterias().length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
    // eslint-disable-next-line
  }, [materias, currentPage, searchText, planEstudioSearch]);

  const paginatedMaterias = filteredMaterias().slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className="buscar">
        <div>
          <Icon name="search" className="bot" />
          <Input
            placeholder="Buscar por materia"
            value={realTimeSearch}
            onChange={(e) => handleRealTimeSearchChange(e.target.value)}
            style={{ marginRight: "12px" }}
            className="busper"
          />
        </div>
        <div>
          <Icon name="search" className="bot" />
          <Input
            placeholder="Buscar por plan de estudio"
            value={planEstudioSearch}
            onChange={(e) => handlePlanEstudioSearchChange(e.target.value)}
            className="busper"
          />
        </div>
      </div>

      <Table className="table-users-admin">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>CLAVE</Table.HeaderCell>
            <Table.HeaderCell>NOMBRE</Table.HeaderCell>
            <Table.HeaderCell>SEMESTRE</Table.HeaderCell>
            <Table.HeaderCell>UNIDADES</Table.HeaderCell>
            <Table.HeaderCell>PLAN DE ESTUDIO</Table.HeaderCell>
            <Table.HeaderCell>ACCIONES</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {map(
            paginatedMaterias.sort((a, b) =>
              compareSemester(a.semestre, b.semestre)
            ),
            (materia, index) => (
              <Table.Row key={index}>
                <Table.Cell>{materia.clave_materia}</Table.Cell>
                <Table.Cell>{materia.nombre_materia}</Table.Cell>
                <Table.Cell>{materia.semestre}</Table.Cell>
                <Table.Cell>{materia.numero_unidades}</Table.Cell>
                <Table.Cell>{materia.plan_estudio_data.descripcion}</Table.Cell>
                <Actions
                  materia={materia}
                  deleteMateria={deleteMateria}
                  updateMateria={updateMateria}
                />
              </Table.Row>
            )
          )}
        </Table.Body>
      </Table>

      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(filteredMaterias().length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(filteredMaterias().length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(filteredMaterias().length / itemsPerPage);

            if (Math.ceil(filteredMaterias().length / itemsPerPage) === 1) {
              return null;
            }
            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            } else if (showStartEllipsis && pageNumber === 1) {
              return (
                <Button key="startEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            } else if (
              showEndEllipsis &&
              pageNumber === Math.ceil(filteredMaterias().length / itemsPerPage)
            ) {
              return (
                <Button key="endEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            }
            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}

function Actions(props) {
  const { materia, deleteMateria, updateMateria } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Actualizar datos materia"
          icon
          className="yellow"
          onClick={() => {
            updateMateria(materia);
          }}
        >
          <Icon name="pencil" style={{ color: "white" }}></Icon>
        </Button>

        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Eliminar materia"
          icon
          negative
          onClick={() => {
            deleteMateria(materia);
          }}
        >
          <Icon name="trash" style={{ color: "white" }}></Icon>
        </Button>

        <Tooltip id="my-tooltip" />
      </div>
    </Table.Cell>
  );
}
